<template>
  <div
    class="modal-backdrop"
    @click="close"
  >
    <div class="modal">
      <div name="header" />
      <div
        id="body"
        name="body"
      >
        <iframe
          width="560"
          height="315"
          :src="'//player.bilibili.com/player.html?aid=' + id"
          scrolling="no"
          border="0"
          frameborder="no"
          framespacing="0"
          allowfullscreen="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      openedAt: null
    }
  },
  mounted () {
    this.openAt = new Date()
    window.ga('send', {
      hitType: 'event',
      eventCategory: 'VideoBiliBili',
      eventAction: `play-${this.id}`
    })
  },
  methods: {
    close () {
      window.ga('send', {
        hitType: 'timing',
        timingCategory: 'VideoBiliBili',
        timingVar: 'viewTime',
        timingValue: new Date() - this.openedAt
      })
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  z-index: 2;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  color: #4AAE9B;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4AAE9B;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4AAE9B;
  border: 1px solid #4AAE9B;
  border-radius: 2px;
}

#body {
  overflow: hidden;
  height: 65vh;
  position: relative;
  width: 80vw;
}

@media screen and (max-width: 768px) {
  #body {
    width: 95vw;
  }
}
#body iframe, #body object, #body embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/modal-video-bilibili.vue